import { useGetFeatureQuery } from "../featuresSlice";
import useRefresher from "../../../hooks/useRefresher";

const useFeature = ({ id }) => {
  const feature = useGetFeatureQuery({ id }, { skip: id == null });
  useRefresher(feature);

  return feature;
};

export default useFeature;
